const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogTermo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogTermo`, params);
    },
    $obterRelatorioLogCSVTermo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeTermoCsv`, params);
    },
    $obterRelatorioLogPDFTermo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeTermoPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;